import { Controller } from "@hotwired/stimulus";
import { httpRequest } from "../http";

export default class extends Controller {
  static targets = [
    "contributionsContainer",
    "addButton",
    "headerButton",
    "expandIcon",
    "collapseIcon",
    "yesRadio",
    "noRadio",
  ];
  static values = {
    createContributionUrl: String,
  };

  connect() {
    // If Yes is already selected, ensure section is expanded
    if (this._getReceivesContributionsValue()) {
      this._expandSection();
    }
  }

  toggleReceivesContributions(event) {
    const receivesContributions = this._getReceivesContributionsValue();

    if (receivesContributions) {
      // When Yes is clicked, expand the section and enable icon
      this._setIconEnabled(true);
      this._expandSection();
    } else {
      // When No is clicked, collapse the section and gray out icon
      this._collapseSection();
      this._setIconEnabled(false);
    }
  }

  // Handle clicks on the header button (expand icon + title)
  handleHeaderClick(event) {
    // Only allow toggling if Yes is selected
    if (this._getReceivesContributionsValue()) {
      this._toggleSection();
    }
    // If No is selected or nothing selected, do nothing (disabled)
  }

  createContribution() {
    httpRequest(this.createContributionUrlValue, { method: "POST" })
      .then((response) => response.text())
      .then((html) =>
        this.contributionsContainerTarget.insertAdjacentHTML("beforeend", html)
      )
      .then(() => {
        this.updateParentSectionHeight();
        this.contributionsContainerTarget
          .querySelector("[data-contribution-entry]:last-child")
          .scrollIntoView({ behavior: "smooth" });
      });
  }

  onContributionDeleted() {
    // Update parent section height after deletion
    this.updateParentSectionHeight();
  }

  updateParentSectionHeight() {
    // Find the parent collapsible section
    const collapsibleSection = this.element.closest(
      '[data-controller*="collapsible-section"]'
    );
    if (collapsibleSection) {
      const bodyElement = collapsibleSection.querySelector(
        "[data-collapsible-section-target='body']"
      );
      if (bodyElement && !bodyElement.classList.contains("hidden")) {
        // Update max-height to accommodate new content
        requestAnimationFrame(() => {
          bodyElement.style.maxHeight = bodyElement.scrollHeight + "px";
        });
      }
    }
  }

  _expandSection() {
    const collapsibleController = this._getCollapsibleController();
    if (collapsibleController && !collapsibleController.expandedValue) {
      collapsibleController.setState(true);
    }
  }

  _collapseSection() {
    const collapsibleController = this._getCollapsibleController();
    if (collapsibleController && collapsibleController.expandedValue) {
      collapsibleController.setState(false);
    }
  }

  _toggleSection() {
    const collapsibleController = this._getCollapsibleController();
    if (collapsibleController) {
      collapsibleController.toggle();
    }
  }

  _getCollapsibleController() {
    const collapsibleSection = this.element.closest(
      '[data-controller*="collapsible-section"]'
    );
    if (collapsibleSection) {
      return this.application.getControllerForElementAndIdentifier(
        collapsibleSection,
        "collapsible-section"
      );
    }
    return null;
  }

  _setIconEnabled(enabled) {
    if (this.hasExpandIconTarget) {
      if (enabled) {
        this.expandIconTarget.classList.remove("opacity-40");
      } else {
        this.expandIconTarget.classList.add("opacity-40");
      }
    }
  }

  _getReceivesContributionsValue() {
    const yesRadio = document.querySelector(
      'input[name="living_wage_gap_calculation[receives_living_wage_contributions]"][value="true"]'
    );
    return yesRadio && yesRadio.checked;
  }
}
